export async function canUseThis(menuKey, store) {
  const deduction = store.getters.getDeductionValue(menuKey)
  const currentLydia = store.getters.getLydia
  const isAuthenticated = store.getters.isAuthenticated // 인증 상태 확인

  console.log(
    `[canUseThis] 메뉴 키: ${menuKey}, 필요 Lydia: ${deduction}, 현재 Lydia: ${currentLydia}, 인증됨: ${isAuthenticated}`,
  )

  // 사용자가 인증되지 않았거나(로그인되지 않았거나) lydia 정보가 없으면 메뉴 사용 불가
  // 현재 시스템은 accessToken으로 인증 상태를 확인하므로 isAuthenticated를 확인합니다.
  if (!isAuthenticated) {
    console.log(`[canUseThis] 사용자가 인증되지 않았습니다. 메뉴 사용 불가.`)
    // 사용자에게 로그인 또는 정보 입력 안내 (라우터 가드에서 처리하는 것이 일반적)
    // 여기서는 단순히 메뉴 사용 불가로 처리하고 false 반환
    return false
  }

  // Lydia 잔액 확인
  if (currentLydia >= deduction) {
    console.log(`[canUseThis] Lydia 잔액 충분. ${menuKey} 사용 가능.`)
    return true // Lydia 충분, 메뉴 사용 가능
  } else {
    console.log(
      `[canUseThis] Lydia가 부족하여 ${menuKey}를 사용할 수 없습니다. 필요: ${deduction}, 현재: ${currentLydia}`,
    )
    // 사용자에게 lydia 부족 메시지 표시 또는 충전 안내
    // 여기서는 단순히 메뉴 사용 불가로 처리하고 false 반환
    return false // 잔액 부족
  }
}

export async function deductLydiaForMenu(menuKey, store) {
  const deduction = store.getters.getDeductionValue(menuKey)
  const currentLydia = store.getters.getLydia

  console.log(
    `[deductLydiaForMenu] 메뉴 키: ${menuKey}, 필요 Lydia: ${deduction}, 현재 Lydia: ${currentLydia}`,
  )

  try {
    const success = await store.dispatch('deductLydia', {
      menuKey,
      deductionAmount: deduction,
    })

    if (success) {
      console.log(`[deductLydiaForMenu] ${menuKey} Lydia 차감 성공`)
      return true
    } else {
      console.log(
        `[deductLydiaForMenu] ${menuKey} Lydia 차감 실패 (Firestore 등 문제)`,
      )
      return false
    }
  } catch (error) {
    console.log(
      `[deductLydiaForMenu] ${menuKey} Lydia 차감 중 오류 발생:`,
      error,
    )
    return false
  }
}
